"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExtensionsController", {
    enumerable: true,
    get: function() {
        return ExtensionsController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _extensionsservice = require("~/services/extensions.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ExtensionsController = class ExtensionsController {
    async extensionList(context, baseId, _req) {
        return new _PagedResponse.PagedResponseImpl(await this.extensionsService.extensionList(context, {
            baseId
        }));
    }
    async extensionCreate(context, baseId, body, req) {
        return await this.extensionsService.extensionCreate(context, {
            extension: _extends({}, body, {
                base_id: baseId
            }),
            req
        });
    }
    async extensionRead(context, extensionId) {
        return await this.extensionsService.extensionRead(context, {
            extensionId
        });
    }
    async extensionUpdate(context, extensionId, body, req) {
        return await this.extensionsService.extensionUpdate(context, {
            extensionId,
            extension: body,
            req
        });
    }
    async extensionDelete(context, extensionId, req) {
        return await this.extensionsService.extensionDelete(context, {
            extensionId,
            req
        });
    }
    constructor(extensionsService){
        this.extensionsService = extensionsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/extensions/:baseId'
    ]),
    (0, _extractidsmiddleware.Acl)('extensionList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ExtensionsController.prototype, "extensionList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/extensions/:baseId'
    ]),
    (0, _extractidsmiddleware.Acl)('extensionCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof Partial === "undefined" ? Object : Partial,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ExtensionsController.prototype, "extensionCreate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/extensions/:extensionId'
    ]),
    (0, _extractidsmiddleware.Acl)('extensionRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('extensionId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ExtensionsController.prototype, "extensionRead", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v2/extensions/:extensionId'
    ]),
    (0, _extractidsmiddleware.Acl)('extensionUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('extensionId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof Partial === "undefined" ? Object : Partial,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ExtensionsController.prototype, "extensionUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v2/extensions/:extensionId'
    ]),
    (0, _extractidsmiddleware.Acl)('extensionDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('extensionId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ExtensionsController.prototype, "extensionDelete", null);
ExtensionsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _extensionsservice.ExtensionsService === "undefined" ? Object : _extensionsservice.ExtensionsService
    ])
], ExtensionsController);
